    <template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <emp-lookup
            :class-padding="classPadding"
            v-model="selectedEmp"
            label="Employee Code"
            title="Employee"
            :code-value="true"
            :off-remarks="true"
          ></emp-lookup>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="8" :class="classPadding">
          <v-text-field label="Name" :value="selectedEmp.desc" :class="classPadding"></v-text-field>
        </v-col>

        
      </v-row>
      <v-row>
        <span>Incident Date:</span>
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
            <custom-datepicker
                :class-padding="classPadding"
                label="From"
                v-model="dateFrom"
            ></custom-datepicker>
        </v-col>
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
            <custom-datepicker
                :class-padding="classPadding"
                label="To"
                v-model="dateTo"
            ></custom-datepicker>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" sm="12" md="12" :class="classPadding">
          <v-btn outlined @click.stop="exportReport" :loading="loading" :class="classPadding">Export</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import moment from "moment"
const EmpLookup = () =>
  import("../../maintenance/employee-masterfile/personal-info/Lookup");
const CustomDatepicker = () => import("../../../components/CustomDatepicker");
const API_ENDPOINT_LETTER = "/api/letterContent";

const API_ENDPOINT = "/api/reports";
export default {
  data: () => ({
    classPadding: "my-0 py-0",
    selectedEmp: {},
    signatory: {},
    letterContents: [],
    loading: false,
    messageCode: null,
    dateFrom: null,
    dateTo: null
  }),
  components: {
    EmpLookup,
    CustomDatepicker
  },
  methods: {
    exportReport() {
      this.loading = true;
      var data = {
        EmpCode: this.selectedEmp.code,
        DateFrom: moment(this.dateFrom).format("MM/DD/YYYY"),
        DateTo: moment(this.dateTo).format("MM/DD/YYYY")
      };
      this.$axios
        .post(`${API_ENDPOINT}/disc-profile-emp`, data)
        .then(({ data }) => {
          var subPath = process.env.VUE_APP_PATH;

          window.open(
            `${subPath.slice(0, -1)}/report-viewer?reportCode=${
              data.reportCode
            }&dbName=${data.dbName}&key=${data.key}&companyKey=${
              data.companyKey
            }&reportUrl=${data.url}&client=${data.client}&logoAlign=${
              data.logoAlign
            }&logoWidth=${data.logoWidth}&rpt=${data.rpt}`
          );
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>